import React, { useRef, useEffect, useState } from 'react'
import ProgressBarWindow from './ProgressBarWindow'
import styles from './CompanyInfo.module.scss'
import CompanyLogo from './CompanyLogo'
import { formatPrice, marketCapFormat,  } from '../utils/tools'
import Tag from './ui/Tag'
import { Divider, Skeleton, Typography } from '@mui/material'
import CompanyData from './CompanyData'
import PercentageWithArrow from './ui/PercentageWithArrow'
import CompanyinfoBox from './CompanyinfoBox'
// import CompanyEarnings from './CompanyEarnings'
// import { useProject } from '../context/project'

export default function CompanyInfo({tickerInfo, ticker, projectId, setOpenAlertsBoard, earningsData}) {
  const [ isStickyCompanyInfo, setIsStickyCompanyInfo ] = useState(false)
  const ref = useRef()
  // const { privateCompany } = useProject()

  const scrollHandler = () => {
    ref.current?.getBoundingClientRect().top < 0 ? setIsStickyCompanyInfo(true) : setIsStickyCompanyInfo(false)
  }

  useEffect(() => {
    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler)
  }, [])

  const companyInfo = (Object.keys(tickerInfo).length > 1 
    ? (<div className={styles["infoBox"]}> 
      <div className={styles["infoContainer"]} ref={ref}>
        {/* <CompanyinfoBox title='Closing Price' info={tickerInfo.stockPrice ? `${tickerInfo.currency_code}${tickerInfo.currency_symbol}${tickerInfo.stockPrice}` : '-'}> */}
        <CompanyinfoBox title='Closing Price' info={tickerInfo.stockPrice ? `${tickerInfo.currency_symbol?tickerInfo.currency_symbol:tickerInfo.currency_code}${parseFloat(tickerInfo.stockPrice).toFixed(2)}` : '-'}>
            {tickerInfo.stockPrice && 
              <span className={styles['showcase-price']}>
                <span>{formatPrice(tickerInfo.changeInStockPrice, 'always', 'en-US',tickerInfo.currency_code)}</span>
                <PercentageWithArrow number={tickerInfo.changePercent}/>
              </span>
              }
        </CompanyinfoBox>
        <Divider orientation="vertical"/>
        {/* <CompanyinfoBox title='Exchange' info={tickerInfo.exchange?.includes('NEW YORK STOCK') ? 'NYSE' : tickerInfo.exchange || "-"}/> */}
        <CompanyinfoBox title='Exchange' 
        // info={tickerInfo?.exchange?tickerInfo?.exchange : "-"}
        >
          <span className={styles["companyDetail-Exchange"]}>{tickerInfo?.exchange?tickerInfo?.exchange : "-"}</span>
        </CompanyinfoBox>
        <Divider orientation="vertical"/>
        <CompanyinfoBox title='Market Cap' info={
          // marketCapFormat(tickerInfo.marketCap)}
          formatPrice(parseFloat(tickerInfo.marketCap / 1000000000), 'auto','en-US',tickerInfo.currency_code)+'B'
          }
          />
        <Divider orientation="vertical"/>
        <CompanyinfoBox title='52 Week High/Low'>
          <ProgressBarWindow precent={tickerInfo.stockPrice/(tickerInfo.week52high/100)} tag={{'Low':formatPrice(tickerInfo.week52low, 'never', 'en-US',tickerInfo.currency_code)}} secondTag={{'High':formatPrice(tickerInfo.week52high, 'never', 'en-US',tickerInfo.currency_code)}}/>
          {tickerInfo.ytdChangePercent && 
                <span className={styles['ytdChangePercent']}>YTD % Change  <PercentageWithArrow number={tickerInfo.ytdChangePercent}/></span> 
              }
        </CompanyinfoBox>
        <Divider orientation="vertical"/>
        <CompanyinfoBox title='Sector / Industry'>
            <div className='sector-industry'>{`${tickerInfo.sector} /`}</div><div>{tickerInfo.industry}</div>
        </CompanyinfoBox>
      </div>
    </div>) 
    : <Skeleton className={styles["infoContainer"]} variant="rect" height='115px'/>)
  
  return (
    <>
      <div className={styles['infoDiv']}>
        <CompanyData tickerInfo={tickerInfo} ticker={ticker} projectId={projectId} setOpenAlertsBoard={setOpenAlertsBoard}/>
        {companyInfo}
      </div>
      {/* {!privateCompany && <CompanyEarnings earningsData={earningsData}/>} */}
      <div className={`${styles['sticky-company-info']} ${isStickyCompanyInfo ? styles['show'] : styles['hide']}`}> 
          <CompanyLogo image={tickerInfo?.image} ticker={ticker} size={32}/>
          <Typography variant="h2">{tickerInfo?.companyName}</Typography>
          <Tag label={ticker}/>
       </div>
    </>
  )
}